import { OverflowMenuController } from './overflow-menu.controller';
import { OverflowMenuProps } from './overflow-menu.model';

export const OverflowMenu = (props: OverflowMenuProps) => {
  return <OverflowMenuController {...props} />;
};
